/**
 * MIGRATED: BannerContext para pages/home usando @a365/core
 * 
 * @deprecated Este contexto ha sido migrado a @a365/core
 * Por favor use directamente BannerProvider de @a365/core
 * Fecha de migración: 2025-05-29
 */

import React from "react";
import { 
  BannerProvider as CoreBannerProvider, 
  useBanner as useCoreBanner,
  BANNER_STRATEGIES
} from "@a365/core";

// Re-exportar para mantener compatibilidad
export const useBanner = useCoreBanner;

export const BannerProvider = ({ children }) => {
  return (
    <CoreBannerProvider strategy={BANNER_STRATEGIES.AUTO}>
      {children}
    </CoreBannerProvider>
  );
};
